import { render, staticRenderFns } from "./TrainingPage.vue?vue&type=template&id=7afb7943&"
import script from "./TrainingPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TrainingPage.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports